// cdl-chatbot.js
// Widget chat IA pour Ciel de Lin
// Communique avec le workflow n8n via webhook

(function () {
  const WEBHOOK_URL = 'https://n8n.monserveurplex.com/webhook/chatbot-cieldelin';
  const MSG_WELCOME = 'Bonjour ! 👋 Je suis l\'assistant Ciel de Lin. Comment puis-je vous aider à choisir votre ciel de lit ?';

  let history = [];
  let isOpen = false;
  let isTyping = false;

  // ── Éléments DOM ──
  const btn = document.getElementById('cdl-chat-btn');
  const window_ = document.getElementById('cdl-chat-window');
  const messages = document.getElementById('cdl-chat-messages');
  const input = document.getElementById('cdl-chat-input');
  const sendBtn = document.getElementById('cdl-chat-send');

  if (!btn || !window_) return;

  // ── Toggle fenêtre ──
  btn.addEventListener('click', () => {
    isOpen = !isOpen;
    btn.classList.toggle('is-open', isOpen);
    window_.classList.toggle('is-open', isOpen);
    if (isOpen && messages.children.length === 0) {
      addMessage('bot', MSG_WELCOME);
      input.focus();
    }
    if (isOpen) setTimeout(() => input.focus(), 300);
  });

  // ── Envoi message ──
  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  async function sendMessage() {
    const text = input.value.trim();
    if (!text || isTyping) return;

    input.value = '';
    addMessage('user', text);
    history.push({ role: 'user', content: text });

    showTyping();
    isTyping = true;

    try {
      const res = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, history: history.slice(-10) }),
      });

      const data = await res.json();
      const reply = data.reply || 'Désolé, je n\'ai pas pu répondre. Réessayez dans un instant.';

      hideTyping();
      addMessage('bot', reply);
      history.push({ role: 'assistant', content: reply });
    } catch (err) {
      hideTyping();
      addMessage('bot', 'Une erreur est survenue. Veuillez réessayer ou nous contacter par email.');
    } finally {
      isTyping = false;
    }
  }

  // ── Afficher un message ──
  function addMessage(role, text) {
    const div = document.createElement('div');
    div.className = `cdl-chat-msg cdl-chat-msg--${role}`;

    const bubble = document.createElement('div');
    bubble.className = 'cdl-chat-msg__bubble';
    bubble.textContent = text;

    div.appendChild(bubble);
    messages.appendChild(div);
    scrollToBottom();
  }

  // ── Typing indicator ──
  function showTyping() {
    const el = document.createElement('div');
    el.className = 'cdl-chat-typing';
    el.id = 'cdl-chat-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    messages.appendChild(el);
    scrollToBottom();
  }

  function hideTyping() {
    const el = document.getElementById('cdl-chat-typing');
    if (el) el.remove();
  }

  function scrollToBottom() {
    messages.scrollTop = messages.scrollHeight;
  }
})();
